import "../../style/mobile/home/M_MainSlider.scss";
import Slider from "react-slick";
import slide1 from "../../../assets/mobile/home/fakurian-design-58Z17lnVS4U-unsplash (1).png";
// import slide2 from '../../../assets/mobile/home/tushar-khandagale-dvtAuBHBAVQ-unsplash.jpg';

let data = [
  {
    id: 1,
    img: slide1,
    title: "کاربرد مغز در زندگی بشریت چیست ؟ ",
    subtitle:
      "وسیله ای که هیچ وقت از آن استفاده نمی کنیم و این متن برای بررسی عملکرد درست قرار گرفته",
  },
  {
    id: 2,
    img: slide1,
    title: "آزمون‌های مدرن",
    subtitle: "آشنایی با جدیدترین روش های برگزاری آزمون در جهان",
  },
  {
    id: 3,
    img: slide1,
    title: "تفکر خارج ار چارچوب",
    subtitle: "روشی برای افزایش خلاقیت در انجام کارها و حل مشکلات",
  },
  {
    id: 4,
    img: slide1,
    title: "آموزش درست",
    subtitle: "آموزش درست چیست و چه ویژگی‌هایی دارد؟",
  },
];

const M_MainSlider = () => {
  var settings = {
    dots: true,
    infinite: false,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    className: "",
  };
  return (
    <div className="M-MainSlider">
      <Slider {...settings}>
        {data.map((item) => (
          <div className="M-MainSlider-item" key={item.id}>
            <img
              className="M-MainSlider-item-img"
              src={item.img}
              alt="slider-img"
            />
            <div className="M-MainSlider-item-text">
              <div className="M-MainSlider-item-text-title">{item.title}</div>
              <div className="M-MainSlider-item-text-subtitle">
                {item.subtitle}
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default M_MainSlider;
